var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconObComms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ob-comms",
    transform: "translate(-308 -969)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(308 969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3848",
    "data-name": "Group 3848",
    transform: "translate(317.083 990.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2965",
    "data-name": "Group 2965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M74.22,34.33V30.368a4.705,4.705,0,0,1,4.69-4.69H132.4a4.705,4.705,0,0,1,4.69,4.69v17.2a4.7,4.7,0,0,1-4.69,4.689H78.91a4.7,4.7,0,0,1-4.69-4.689V34.33Z",
    transform: "translate(-64.176 -23.662)",
    fill: "#88c4ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M60.884,36.288l8.029-4.635V27.691A4.7,4.7,0,0,1,73.6,23H127.1a4.7,4.7,0,0,1,4.689,4.69v17.2a4.7,4.7,0,0,1-4.689,4.69H73.6a4.7,4.7,0,0,1-4.69-4.69V40.924Z",
    transform: "translate(-60.884 -23.001)",
    fill: "#f1f6ff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2988",
    "data-name": "Group 2988",
    transform: "translate(35.202 9.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M135.382,37.393H108.63a1.008,1.008,0,0,1,0-2.016h26.752a1.008,1.008,0,1,1,0,2.016Z",
    transform: "translate(-107.622 -35.377)",
    fill: "#2092ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2989",
    "data-name": "Group 2989",
    transform: "translate(35.202 15.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M135.382,46.173H108.63a1.008,1.008,0,0,1,0-2.016h26.752a1.008,1.008,0,1,1,0,2.016Z",
    transform: "translate(-107.622 -44.157)",
    fill: "#2092ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2994",
    "data-name": "Group 2994",
    transform: "translate(12.968 5.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2990",
    "data-name": "Group 2990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M95.133,38.191a8.515,8.515,0,1,1-8.515-8.515A8.515,8.515,0,0,1,95.133,38.191Zm-2.016,0h0a6.5,6.5,0,1,0-6.5,6.5A6.5,6.5,0,0,0,93.116,38.191Z",
    transform: "translate(-78.102 -29.676)",
    fill: "#2092ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2993",
    "data-name": "Group 2993",
    transform: "translate(7.508 3.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2991",
    "data-name": "Group 2991",
    transform: "translate(0 3.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M89.078,39.049a1.008,1.008,0,0,1,1.008,1.008v3.9a1.008,1.008,0,1,1-2.016,0v-3.9h0a1.008,1.008,0,0,1,1.008-1.008Z",
    transform: "translate(-88.07 -39.049)",
    fill: "#2092ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2992",
    "data-name": "Group 2992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M89.274,34.9a1.112,1.112,0,0,1,.19.06.933.933,0,0,1,.173.093.778.778,0,0,1,.151.125,1.008,1.008,0,0,1,0,1.423.744.744,0,0,1-.151.124.852.852,0,0,1-.173.093.937.937,0,0,1-.38.079,1.009,1.009,0,1,1-.007-2.018A1.083,1.083,0,0,1,89.274,34.9Z",
    transform: "translate(-88.07 -34.883)",
    fill: "#2092ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2973",
    "data-name": "Group 2973",
    transform: "translate(17.247 31.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2965-2",
    "data-name": "Group 2965",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1663-2",
    "data-name": "Path 1663",
    d: "M82.464,82.131v12.9a4.585,4.585,0,0,1-4.573,4.572H33.079a4.586,4.586,0,0,1-4.573-4.572V78.269A4.587,4.587,0,0,1,33.079,73.7H77.891a4.586,4.586,0,0,1,4.573,4.573v3.863Z",
    transform: "translate(-28.506 -71.73)",
    fill: "#f4d93b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664-2",
    "data-name": "Path 1664",
    d: "M85.14,88.494v3.863a4.586,4.586,0,0,1-4.573,4.573H35.755a4.586,4.586,0,0,1-4.572-4.573V75.592a4.586,4.586,0,0,1,4.572-4.573H80.567a4.586,4.586,0,0,1,4.573,4.573v3.863l7.828,4.519Z",
    transform: "translate(-29.217 -71.019)",
    fill: "#fffab6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2972",
    "data-name": "Group 2972",
    transform: "translate(6.45 8.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2966",
    "data-name": "Group 2966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M37.29,84.114a.982.982,0,0,1,.983-.983H79.495a.983.983,0,1,1,0,1.966H38.273A.983.983,0,0,1,37.29,84.114Z",
    transform: "translate(-37.29 -83.131)",
    fill: "#f4d93b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2967",
    "data-name": "Group 2967",
    transform: "translate(0 6.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M37.29,92.895a.982.982,0,0,1,.983-.983H72.151a.983.983,0,0,1,0,1.966H38.273A.983.983,0,0,1,37.29,92.895Z",
    transform: "translate(-37.29 -91.912)",
    fill: "#f4d93b"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconObComms);
export default __webpack_public_path__ + "static/media/icon-ob-comms.fb1b463f54945ccc7c089bb46a6a63ad.svg";
export { ForwardRef as ReactComponent };